import { push } from 'connected-react-router';
import { createAction, handleActions } from 'redux-actions';

import AuthService from '../services/AuthService';
import { auth } from '../services/api';

export const receiveLogin = createAction('LOGIN');
export const loginError = createAction('LOGIN_ERROR');
export const clearError = createAction('CLEAR_ERROR');
export const receiveLogout = createAction('LOGOUT');

export function login(data: any, redirectTo: string) {
  return (dispatch: Function) =>
    auth
      .login(data)
      .then((json: any) => {
        AuthService.setToken(json.access_token);
        AuthService.setRefreshToken(json.refresh_token);

        dispatch(push(redirectTo ?? '/'));
        dispatch(receiveLogin());
      })
      .catch((json) => {
        dispatch(loginError());
      });
}

export function logout() {
  return (dispatch: Function) => {
    AuthService.logout();
    dispatch(push('/'));
    dispatch(receiveLogout());
  };
}

export default handleActions(
  {
    [receiveLogin](state) {
      return { ...state, loggedIn: true };
    },
    [receiveLogout](state) {
      return { ...state, loggedIn: false };
    },
    [loginError](state) {
      return { ...state, loginError: true };
    },
    [clearError](state) {
      return { ...state, loginError: false };
    },
  },
  { loggedIn: AuthService.loggedIn() }
);
